module.exports = __webpack_public_path__ + "img/Butterfly_00049.10132217.png";